import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import React, { useEffect, useState } from 'react';

import MAvatar from 'components/@material-extend/MAvatar/MAvatar';
import { pointsToLevel } from 'components/Rewards/utils';
import { getGroupStudentPointsBalanceSheet } from 'external/firebase/firestore/collections/groups';
import useAuth from 'hooks/useAuth';
import createAvatar from 'utils/createAvatar';
import { calculateValidPointsForRewards } from 'utils/pointsUtils';

interface MyAvatarProps {
    sx?: SxProps<Theme>;
}

const MyAvatar: React.FunctionComponent<MyAvatarProps> = props => {
    const { user, profile, selectedGroup } = useAuth();
    const userName = user?.displayName || `${profile?.firstName} ${profile?.lastName}` || '';
    const avatar = createAvatar(userName);

    const [studentPoints, setStudentPoints] = useState<number>(0);

    const fetchGroupStudentAttendance = async (groupId: string, userId: string) => {
        try {
            const balanceSheet = await getGroupStudentPointsBalanceSheet(groupId, userId);
            const schoolYearPoints = calculateValidPointsForRewards(balanceSheet);
            setStudentPoints(schoolYearPoints);
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => {
        if (profile?.role === 'child' && selectedGroup) {
            fetchGroupStudentAttendance(selectedGroup.id, profile.id);
        }
    }, [profile, selectedGroup]);

    return (
        // @ts-ignore
        <MAvatar
            src={user?.photoURL}
            alt={userName}
            level={profile?.role === 'child' ? pointsToLevel(studentPoints) : undefined}
            color={user?.photoURL ? 'default' : 'accent'}
            {...props}
        >
            {avatar.name}
        </MAvatar>
    );
};

export default MyAvatar;
